'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Navbar = require('../Navbar.js');
require('./NavLink.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavLink = function (props) {
    var item = props.item, isWithStyle = props.isWithStyle;
    var linkComponent = Navbar.useNavbarContext().linkComponent;
    if (!linkComponent && item.type !== 'spa') {
        return (React__default['default'].createElement(LinkElement, { item: item, isWithStyle: isWithStyle }));
    }
    return linkComponent(React__default['default'].createElement(LinkElement, { item: item, isWithStyle: isWithStyle }), item);
};
var LinkElement = function (props) {
    var item = props.item, isWithStyle = props.isWithStyle;
    return (React__default['default'].createElement("a", { href: item.link, title: item.title, className: (isWithStyle ? 'child__anchor' : '') + " nl-root", onClick: function (e) {
            if (item.type === 'prevent' || item.type === 'spa') {
                e.preventDefault();
            }
            item.onClick && item.onClick(item);
        } },
        item.iconName && (React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--" + item.iconName + " icon" })),
        React__default['default'].createElement("span", null, item.title)));
};
NavLink.defaultProps = {
    isWithStyle: false,
};

exports.NavLink = NavLink;
//# sourceMappingURL=NavLink.js.map
